var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 49,
    viewBox: "0 0 43 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.827148 27.4278C1.53182 34.5523 4.59559 40.6372 10.0338 44.5052C17.2949 49.6575 25.7509 49.9021 30.9746 42.533C36.0145 35.4543 28.5696 27.5501 30.9746 24.2784L33.104 21.2206L22.9782 14.1267L19.7612 18.4228C16.2073 23.4375 22.825 32.4272 20.7416 35.4238C19.2098 37.4877 16.7894 36.4787 14.8745 35.118C12.5307 33.4974 11.2593 29.1249 10.9529 25.6543L0.827148 27.4278ZM30.4232 13.6681C34.2988 16.42 38.8179 15.5944 41.0238 12.4909C43.2297 9.38726 42.5557 5.09116 38.5115 2.27806C36.9828 1.12073 35.064 0.599954 33.1586 0.825192C31.2531 1.05043 29.5094 2.00414 28.2938 3.48586C27.2286 5.11421 26.8545 7.09798 27.2538 9.00141C27.653 10.9048 28.7929 12.5723 30.4232 13.6375V13.6681Z",
    stroke: "#FF8000",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrange);
export default __webpack_public_path__ + "static/media/orange.be6f9237c95a3bf1dac204cd551a6b42.svg";
export { ForwardRef as ReactComponent };